import { render } from "./UpcomingTrips.vue?vue&type=template&id=961611e0"
import script from "./UpcomingTrips.vue?vue&type=script&lang=js"
export * from "./UpcomingTrips.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__